/**
 * @desc 查询开启的活动信息
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** channel */
  channel?: number;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<
    defs.store.GeneralHttpResponse<Array<defs.store.SimpleActivityVO>>
  >(`/storeapi/api/v3/activity/opening`, {
    params,
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<
  Array<defs.store.SimpleActivityVO>
>;
export default req;
